import AuthTypes from "./AuthTypes";

interface AuthState {
  user: null | {
    uid: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  token: string | null;
  loading: boolean;
  error: any | null;

  verify_loading: boolean;
  verify_error: any | null;
}

const initialState: AuthState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  verify_error: null,
  verify_loading: true,
};

const authReducer = (state = initialState, action: any): AuthState => {
  switch (action.type) {
    case AuthTypes.LOGIN_LOADING:
      return {
        ...state,
        loading: true,
        user: null,
        token: null,
        error: null,
      };

    case AuthTypes.LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action?.payload?.user,
        token: action?.payload?.token,
        error: null,
      };

    case AuthTypes.LOGIN_ERROR:
      return {
        ...state,
        loading: false,
        user: null,
        token: null,
        error: action?.payload,
      };

    case AuthTypes.VERIFY_LOADING:
      return {
        ...state,
        verify_loading: true,
        verify_error: null,
        user: null,
        token: null,
      };

    case AuthTypes.VERIFY_SUCCESS:
      return {
        ...state,
        verify_loading: false,
        user: action?.payload?.user,
        token: action?.payload?.token,
        error: null,
      };

    case AuthTypes.VERIFY_ERROR:
      return {
        ...state,
        verify_loading: false,
        user: null,
        token: null,
        verify_error: action?.payload,
      };

    case AuthTypes.LOGOUT:
      return {
        ...state,
        user: null,
        token: null,
        error: null,
        loading: false,
        verify_loading: false,
        verify_error: null,
      };

    default:
      return state;
  }
};

export default authReducer;
